
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/main.css';
import './styles/components.css';
import AppRouter from './components/AppRouter';
import axios from 'axios';

// Utilitaire pour extraire la valeur d'un cookie
const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)'));
    return match ? match[2] : null;
};

// 1. Intercepteur axios global
axios.interceptors.request.use(config => {
    const method = (config.method || 'GET').toUpperCase();
    if (['POST', 'PUT', 'DELETE'].includes(method)) {
        const csrfToken = getCookie('csrfToken');
        if (csrfToken) {
            config.headers['X-CSRF-Token'] = csrfToken;
        }
    }
    return config;
}, error => {
    return Promise.reject(error);
});

// 2. Intercepteur fetch global
const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
    let [resource, config] = args;
    config = config || {};
    const method = (config.method || 'GET').toUpperCase();
    
    if (['POST', 'PUT', 'DELETE'].includes(method)) {
        const csrfToken = getCookie('csrfToken');
        if (csrfToken) {
            config.headers = {
                ...config.headers,
                'X-CSRF-Token': csrfToken
            };
        }
    }
    return originalFetch(resource, config);
};

const App = () => {
    return (
        <BrowserRouter>
            <AppRouter />
        </BrowserRouter>
    );
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
